module.exports = __webpack_public_path__ + "static/img/arrow.49145e0e.png";